<app-tabla
  [totalCount]="totalCount"
  [datos]="reportes"
  [columnas]="columnas"
  [name]="name"
  [pageSizeOptions]="helper.pageSizeOptions"
  [search]="search"
  [filtros]="filtros"
  [(query)]="query"
  (queryChange)="listar()"
  [paginatorArriba]="false"
  [showHijos]="false"
  [emptyState]="{ title: 'No hay reportes de temperatura' }"
></app-tabla>
